import { TPolicyContextActions } from '../actions/TPolicyContextActions';
import { IPolicyContextState } from '../state/IPolicyContextState';
import { eSingleFields } from '../state/eSingleFields';
import { ePolicyContextActionType } from '../actions/ePolicyContextActionType';

export const PolicyContextReducer = (
  oldState: IPolicyContextState,
  action: TPolicyContextActions
): IPolicyContextState => {
  switch (action.type) {
    case ePolicyContextActionType.CloseEditSingleFieldAction:
      return {
        ...oldState,
        isEditingSingleField: false,
        editingSingleFieldName: eSingleFields.estimated_property_value,
      };
    case ePolicyContextActionType.OpenEditSingleFieldAction:
      return { ...oldState, isEditingSingleField: true, editingSingleFieldName: action.payload };
    case ePolicyContextActionType.SetOrder:
      return { ...oldState, order: action.payload };
  }
};
